import { buildLocalPage } from "./_localPageBuilder";

export default buildLocalPage({
  slug: "tms-coconut-creek",
  cityName: "Coconut Creek",
  county: "Broward County",
  distance: "10 minutes east",
  title: "TMS Treatment in Coconut Creek, Florida",
  description:
    "TMS, SAINT®, and SPRAVATO® treatment for Coconut Creek residents at our Coral Springs center. Serving Broward County. Schedule a consultation today.",
  keywords:
    "TMS Coconut Creek, TMS therapy Coconut Creek, SAINT Coconut Creek, depression treatment Coconut Creek FL",
  localContext:
    "Coconut Creek residents can reach our Coral Springs center in about 10 minutes via Sample Road or Coconut Creek Parkway — the two cities share a border, so the commute is minimal. We regularly see patients from the Winston Park and Township Center areas who want advanced options like SAINT® accelerated TMS, SPRAVATO®, and IV ketamine without driving across the county. Because the trip is so short, Coconut Creek patients often choose us for both standard TMS and accelerated protocols.",
});
